.fallback {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    position: relative;
}

/* Decorative ring — expands outward and fades away */
.fallback::before {
    content: "";
    position: absolute;
    width: 340px;
    height: 340px;
    border-radius: 50%;
    border: 1px solid var(--mantine-color-sjøgrønn-2);
    opacity: 0;
    animation: fallback-ring 1.6s var(--transition-ease-smooth) 0.2s forwards;
}

@keyframes fallback-ring {
    0% {
        opacity: 0;
        transform: scale(0.85);
    }
    30% {
        opacity: 1;
    }
    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}

/* Staggered fade-up for children */
.fallbackLabel {
    text-transform: uppercase;
    font-size: var(--mantine-font-size-xs);
    font-weight: 700;
    letter-spacing: 0.12em;
    color: var(--mantine-color-gneis-5);
    opacity: 0;
    animation: fallback-fade-up 0.6s var(--transition-ease-smooth) 0.1s forwards;
}

.fallbackTitle {
    font-size: clamp(1.5rem, 3vw, 2rem);
    font-weight: 400;
    letter-spacing: -0.03em;
    color: $dib-brand-base;
    text-align: center;
    line-height: 1.25;
    max-width: 28ch;
    margin: var(--mantine-spacing-sm) 0 var(--mantine-spacing-xl);
    opacity: 0;
    animation: fallback-fade-up 0.6s var(--transition-ease-smooth) 0.25s
        forwards;
}

.fallbackCta {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    padding: 0.65em 1.4em;
    border-radius: var(--mantine-radius-md);
    background: $dib-brand-base;
    color: #fff;
    font-size: var(--mantine-font-size-md);
    font-weight: 700;
    text-decoration: none;
    transition:
        background var(--transition-duration-normal)
            var(--transition-ease-smooth),
        box-shadow var(--transition-duration-normal)
            var(--transition-ease-smooth);
    opacity: 0;
    animation: fallback-fade-up 0.6s var(--transition-ease-smooth) 0.4s forwards;

    &:hover {
        background: #296d5d;
        box-shadow: 0 2px 8px rgb(1 44 61 / 0.18);
    }

    &:active {
        background: $dib-brand-base;
    }
}

.fallbackCtaIcon {
    width: 1.15em;
    height: 1.15em;
    transition: transform var(--transition-duration-normal)
        var(--transition-ease-spring);

    .fallbackCta:hover & {
        transform: translate(2px, -2px);
    }
}

@keyframes fallback-fade-up {
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
